import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import cn from 'classnames'

import Chip from 'react-toolbox/lib/chip'

import styles from './styles.scss'

const ChipFilter = ({ onClick, deletable, inverse, label }) => {
  let classes = []
  if (inverse)
    classes = [...classes, styles.inverse]

  return (
    <Chip
      deletable={deletable}
      onClick={onClick}
      class={classes.join(' ')}
      theme={styles}
    >
      <span>
        { label }
      </span>
    </Chip>
  )
}

const withStyle = CSSModules(styles)
export default withStyle(ChipFilter)
